<script setup lang="ts">
import { ref } from 'vue'

import { getClasses } from '~/js/composables/classes'

interface Props {
    utilities?: string
}

withDefaults(defineProps<Props>(), {
    utilities: '',
})

const classes = ref({
    _default: 'place-self-start inline-flex',
    border: 'border border-indigo rounded-lg',
    color: 'bg-indigo',
    size: 'w-fit whitespace-nowrap',
    spacing: 'px-4 py-1',
    text: 'text-white text-sm font-primary',
})
</script>

<template>
    <span 
        :class="[getClasses(classes), utilities]" 
    >
        <slot></slot>
    </span>
</template>